import React from 'react';
import { Button } from '@mui/material';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import { aiGradientButtonSx } from '../../constants/aiButton';

/**
 * Primary AI action button — teal gradient matching dashboard accent.
 */
const AiGradientButton = ({
  startIcon,
  showSparkle = true,
  sx,
  variant = 'contained',
  children,
  ...props
}) => {
  const resolvedStartIcon =
    startIcon !== undefined ? startIcon : showSparkle ? <AutoAwesomeIcon /> : undefined;

  return (
    <Button
      variant={variant}
      startIcon={resolvedStartIcon}
      sx={aiGradientButtonSx(sx)}
      {...props}
    >
      {children}
    </Button>
  );
};

export default AiGradientButton;
